import { MutationCache, QueryClient } from '@tanstack/react-query';
import { isWorkItemTombstonedError } from './api';

interface ApiError {
  status?: number;
}

export const queryClient = new QueryClient({
  mutationCache: new MutationCache({
    onError: (error) => {
      // A mutation that hit a tombstoned work item (410) means this tab predates the deletion:
      // refetch every work-item query so the banner appears and the actions disable.
      if (isWorkItemTombstonedError(error)) {
        void queryClient.invalidateQueries({ queryKey: ['work-item'] });
      }
    },
  }),
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: (failureCount, error: unknown) => {
        const apiError = error as ApiError;
        // Don't retry on 4xx errors
        if (apiError?.status && apiError.status >= 400 && apiError.status < 500) {
          return false;
        }
        return failureCount < 3;
      },
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: false,
    },
  },
});
